import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Analytics, logEvent } from '@angular/fire/analytics';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { NgsRevealConfig } from 'ngx-scrollreveal';
import { Subscription } from 'rxjs';

import { LoggerService } from '../../shared/services/logger.service';
import { VERSION } from '../../../environments/version';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  providers: [NgsRevealConfig],
  imports: [RouterLink],
})
export class FooterComponent implements OnInit, OnDestroy {
  private analytics = inject(Analytics);
  public paginaInicial = false;
  public version = VERSION;
  private routerSub: Subscription;

  constructor(
    private router: Router,
    public revealConfig: NgsRevealConfig,
    private logger: LoggerService
  ) {
    revealConfig.duration = 5000;
    revealConfig.easing = 'cubic-bezier(0.645, 0.045, 0.355, 1)';
  }

  ngOnInit() {
    this.routerSub = this.router.events.subscribe(val => {
      if (val instanceof NavigationEnd) {
        if (val.url == '/') {
          this.paginaInicial = true;
        } else {
          this.paginaInicial = false;
        }
      }
    });
  }

  logEvent(siteName: string) {
    this.logger.debug('footer:RegLink');
    logEvent(this.analytics, 'link_externo', { dst: siteName });
  }

  ngOnDestroy(): void {
    if (this.routerSub) {
      this.routerSub.unsubscribe();
    }
  }
}
